import { responseErrorHandle, changeCodeName } from '@/utils/utils';
import { 
  getConfigTemplateList,
  queryGovExpendEconomicClassify,
  queryDepExpendEconomicClassify,
  addOrEditConfigTemplate,
  getConfigTemplateChooseList,
  getConfigTemplateDefaultList,
  checkTemplateName,
  changeConfigTemplateStatus,
  searchActiveCount,
  deleteConfigTemplate,
  getConfigTemplateDetail,
  exportConfigTemplate,
  getDownLoadUrl,
  previewTemplate,
  saveTemplate
} from '../services/index';

export default {
  namespace: 'templateManage',
  state: {
    govExpendEconomicClassifyList: [],
    depExpendEconomicClassifyList: [],
    projectList: [],
    // 应发项
    IssuedItems: [],
    // 应扣项
    deductionItems: [],
    // 实发项
    actualIssuedItems: [],
    // 实扣项
    actualDeductionItems: [],
  },
  effects: {
    // 获取工资模板列表
    * getConfigTemplateList ({ payload }, { call }) {
      try {
        const res = yield call(getConfigTemplateList, payload);
        responseErrorHandle(res);
        return res;
      }catch (e) { }
    },

    // 获取政府经济科目列表
    * queryGovExpendEconomicClassify ({ payload }, { call, put }) {
      const res = yield call(queryGovExpendEconomicClassify);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          govExpendEconomicClassifyList: changeCodeName(res?.result || [], ['name', 'code']),
        },
      });
      return res;
    },

    // 获取部门经济科目列表
    * queryDepExpendEconomicClassify ({ payload }, { call, put }) {
      const res = yield call(queryDepExpendEconomicClassify, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          depExpendEconomicClassifyList: changeCodeName(res?.result || [], ['name', 'code']),
        },
      });
      return res;
    },

    // 新增、编辑工资模板
    * addOrEditConfigTemplate ({ payload }, { call }) {
      const res = yield call(addOrEditConfigTemplate, payload);

      return res;
    },
    

    // 获取工资项目可选列表
    * getConfigTemplateChooseList ({ payload }, { call }) {
      const res = yield call(getConfigTemplateChooseList, payload);
      responseErrorHandle(res);

      return res;
    },

    // 获取工资项目默认选项
    * getConfigTemplateDefaultList ({ payload }, { call }) {
      const res = yield call(getConfigTemplateDefaultList, payload);
      responseErrorHandle(res);

      return res;
    },

    // 新增模板时，检测模板名称是否可用
    * checkTemplateName ({ payload }, { call }) {
      const res = yield call(checkTemplateName, payload);
      responseErrorHandle(res);

      return res;
    },

    // 启用、停用工资模板
    * changeConfigTemplateStatus ({ payload }, { call }) {
      const res = yield call(changeConfigTemplateStatus, payload);
    
      return res;
    },
    // 保存工资模板
    * saveTemplate ({ payload }, { call }) {
      return yield call(saveTemplate, payload);
    },
    // 查看机构有多少个启用的工资模板
    * searchActiveCount ({ payload }, { call }) {
      const res = yield call(searchActiveCount, payload);
      responseErrorHandle(res);
      return res;
    },
   
    // 删除工资模板
    *  deleteConfigTemplate ({ payload }, { call }) {
      const res = yield call( deleteConfigTemplate, payload);
      responseErrorHandle(res);

      return res;
    },

    // 查询工资模板详情
    *  getConfigTemplateDetail ({ payload }, { call }) {
      const res = yield call( getConfigTemplateDetail, payload);
      responseErrorHandle(res);

      return res;
    },


    // 导出工资模板
    * exportConfigTemplate ({ payload }, { call }) {
      const res = yield call( exportConfigTemplate, payload);
      responseErrorHandle(res);

      return res;
    },

    // 下载附件
    * getDownLoadUrl ({ payload }, { call }) {
      const res = yield call( getDownLoadUrl, payload);
      responseErrorHandle(res);

      return res;
    },

    // 预览模版
    * previewTemplate ({ payload }, { call }) {
      const res = yield call( previewTemplate, payload);
      responseErrorHandle(res);

      return res;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
